import api from '../lib/api';
import type {
  DashboardStats,
  DashboardKPIs,
  DashboardTrends,
  StatsByRange,
  ClosedTicketsByMonth,
  OpenTicketsLast30Days,
  ClosedTicketsLast30Days,
  TokensUsageLast30Days,
  TokensUsageLast6Months
} from '../types/dashboard';

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get('/dashboard');
    return response.data;
  },

  async getKPIs(): Promise<DashboardKPIs> {
    const response = await api.get('/dashboard/kpis');
    return response.data;
  },

  async getTrends(
    metric: 'messages' | 'tickets' | 'leads' | 'emails' | 'appointments',
    period: 'daily' | 'weekly' | 'monthly' | 'yearly',
    days?: number
  ): Promise<DashboardTrends> {
    const params: any = { metric, period };
    if (days) params.days = days;

    const response = await api.get('/dashboard/trends', { params });
    return response.data;
  },

  async getStatsByRange(startDate: string, endDate: string): Promise<StatsByRange> {
    const response = await api.get('/dashboard/stats-by-range', {
      params: { start_date: startDate, end_date: endDate }
    });
    return response.data;
  },

  async getClosedTicketsByMonth(): Promise<ClosedTicketsByMonth> {
    const response = await api.get('/dashboard/closed-tickets-by-month');
    return response.data;
  },

  async getOpenTicketsLast30Days(): Promise<OpenTicketsLast30Days> {
    const response = await api.get('/dashboard/open-tickets-last-30-days');
    return response.data;
  },

  async getClosedTicketsLast30Days(): Promise<ClosedTicketsLast30Days> {
    const response = await api.get('/dashboard/closed-tickets-last-30-days');
    return response.data;
  },

  async getTokensUsageLast30Days(): Promise<TokensUsageLast30Days> {
    const response = await api.get('/dashboard/tokens-usage-last-30-days');
    return response.data;
  },

  async getTokensUsageLast6Months(): Promise<TokensUsageLast6Months> {
    const response = await api.get('/dashboard/tokens-usage-last-6-months');
    return response.data;
  }
};
